import React from 'react';


const Light = (
  {
    className,
    isGreen,
    tooltipText,
    showTooltip,
    hideTooltip,
    tooltipIsShown
  }
) => {
  return (
    <div
      style={{position: 'relative'}}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      <i
        className={`fas fa-lightbulb ${className}`}
        style={{color: isGreen ? '#00bc2c' : 'rgba(0, 0, 0, 0.5)'}}
      />
      <span
        style={{
          display: tooltipIsShown ? 'flex' : 'none',
          position: 'absolute',
          top: '-75px',
          left: '-50px',
          backgroundColor: 'lightsteelblue',
          padding: '10px',
          borderRadius: '4px',
          zIndex: '100000000000000000000000000',
          width: '100px',
          fontSize: '16px'
        }}

      >
        {tooltipText}
      </span>
    </div>
  )
};

export default Light;



// WEBPACK FOOTER //
// ./src/components/light/light-component.js